import { Tooltip } from "@octopusdeploy/design-system-components";
import { ArrowRotateIcon, EqualsIcon, MinusSquareIcon, PlusSquareIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type { KubernetesResourceManifestDiffResult } from "@octopusdeploy/octopus-server-client";
import React from "react";
export const ManifestDiffResultIcon = ({ diffResult, deploymentName }: {
    diffResult: KubernetesResourceManifestDiffResult;
    deploymentName: string;
}) => {
    switch (diffResult) {
        case "Added":
            return (<Tooltip content={`Manifest added in ${deploymentName}`}>
                    <PlusSquareIcon size={20} color={themeTokens.color.icon.success}/>
                </Tooltip>);
        case "Removed":
            return (<Tooltip content={`Manifest not found in ${deploymentName}`}>
                    <MinusSquareIcon size={20} color={themeTokens.color.icon.danger}/>
                </Tooltip>);
        case "Changed":
            return (<Tooltip content={`Manifest updated in ${deploymentName}`}>
                    <ArrowRotateIcon size={20} color={themeTokens.color.icon.info}/>
                </Tooltip>);
        case "Unchanged":
            return (<Tooltip content={`Manifest unchanged in ${deploymentName}`}>
                    <EqualsIcon size={20} color={themeTokens.color.icon.secondary}/>
                </Tooltip>);
    }
};
